<template>
  <div class="loading">
    <img v-if="type == 1" src="@/assets/images/error/no_data.png" />
    <img v-if="type == 2" src="@/assets/images/error/404.png" />
    <p>{{ tips }}</p>
  </div>
</template>

<script>
export default {
  name: "no_data",
  props: {
    type: {
      type: Number,
      default: 1
    },
    tips: {
      type: String,
      default: "暂无数据"
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.loading {
  height: 100%;
  width: 100%;
  display: flex;
  background: #fff;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  img {
    width: 208px;
    height: 163px;
  }
  p {
    color: #8d8d8d;
    font-size: 0.8em;
  }
}
</style>
